import ViewSolidSVG from "@design-system/ui-icons/vanilla/ViewSolid"
import { createIcon } from "../createIcon"

export const ViewSolidIcon = createIcon(ViewSolidSVG)
